<template>
  <div>
    <div v-for="(row, i) in chronologies" :key="i">
      <LMarker :lat-lng="[row.lat, row.lng]" @click="show(row)">
        <LIcon :options="{ html: row.iconHtml }" :icon-anchor="[18, 36]" />
        <l-tooltip :options="tooltipOptions" v-if="!isMobile">
          <div class="caption grey--text text--darken-3">
            <div class="text-right" v-if="false">ID {{ row.id }}</div>
            <div class="font-weight-bold">
              {{ row.jst }}
            </div>
            <template v-if="row.notes">
              <div
                style="white-space: normal;"
                :style="{
                  width: row.notes.length > 40 ? '300px' : 'auto'
                }"
              >
                {{ row.notes }}
              </div>
            </template>
          </div>
        </l-tooltip>
      </LMarker>
    </div>
    <ChronologyDetail
      :dialog="isShowDialog"
      :data="target"
      @close="isShowDialog = false"
    />
  </div>
</template>
<script>
import { LMarker, LTooltip, LIcon } from "vue2-leaflet";
import ChronologyDetail from "./ChronologyDetail";
import moment from "moment";
export default {
  name: "ChronologyLayer",

  components: {
    LMarker,
    LTooltip,
    LIcon,
    ChronologyDetail
  },

  props: {
    map: {
      type: Object,
      required: true
    }
  },

  data() {
    return {
      markerLayer: null,
      markers: [],
      isShowDialog: false,
      target: null,
      tooltipOptions: {
        direction: "top",
        offset: [0, -36]
      }
    };
  },

  computed: {
    chronologies() {
      const arr = JSON.parse(JSON.stringify(this.$store.getters.chronologies));
      const targets = arr.filter(c => c.lat && c.lng);
      targets.forEach(c => {
        c.iconHtml = `<div class="v-icon notranslate mdi ${c.icon} theme--light" style="color: ${c.color}; font-size: 28px;" />`;
        if (c.progress) {
          c.progress.date = moment
            .utc(c.progress.date, "YYYYMMDDHHmm")
            .local()
            .format("YYYY年MM月DD日 HH:mm");
        }
      });
      return targets;
    },
    isMobile() {
      return this.$route.path === "/mobile-chronology";
    }
  },

  methods: {
    show(row) {
      this.$store.commit("SET_SELECTED_CHRONOLOGY", row);
      this.target = row;
      this.isShowDialog = true;
      this.map.panTo([row.lat, row.lng]);
    }
  }
};
</script>

<style lang="scss" scoped>
//
</style>
